(function () {
  const MOBILE_QUERY = '(max-width: 749px)';

  class WxclUgcCarousel {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-wxcl-track]');
      this.slides = Array.from(root.querySelectorAll('[data-wxcl-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-wxcl-dot]'));
      this.prevBtn = root.querySelector('[data-wxcl-prev]');
      this.nextBtn = root.querySelector('[data-wxcl-next]');
      this.index = 0;
      this.mediaQuery = window.matchMedia(MOBILE_QUERY);
      this.onMediaChange = this.onMediaChange.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);

      this.prevBtn?.addEventListener('click', this.onPrev);
      this.nextBtn?.addEventListener('click', this.onNext);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

      this.mediaQuery.addEventListener('change', this.onMediaChange);
      this.update();
    }

    isActive() {
      return this.mediaQuery.matches && this.slides.length > 0;
    }

    onMediaChange() {
      this.index = 0;
      this.update();
    }

    onPrev() {
      this.goTo(this.index - 1);
    }

    onNext() {
      this.goTo(this.index + 1);
    }

    goTo(index) {
      if (!this.isActive()) return;
      const last = this.slides.length - 1;
      this.index = Math.max(0, Math.min(index, last));
      this.update();
    }

    update() {
      if (!this.track) return;

      if (!this.isActive()) {
        this.track.style.transform = '';
        this.dots.forEach((dot, i) => {
          const active = i === 0;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.setArrowState();
        return;
      }

      this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.setArrowState();
    }

    setArrowState() {
      if (!this.isActive()) {
        this.prevBtn?.removeAttribute('disabled');
        this.nextBtn?.removeAttribute('disabled');
        return;
      }

      this.prevBtn?.toggleAttribute('disabled', this.index === 0);
      this.nextBtn?.toggleAttribute('disabled', this.index >= this.slides.length - 1);
    }

    destroy() {
      this.prevBtn?.removeEventListener('click', this.onPrev);
      this.nextBtn?.removeEventListener('click', this.onNext);
      this.mediaQuery.removeEventListener('change', this.onMediaChange);
    }
  }

  function initCarousels(scope) {
    scope.querySelectorAll('[data-wxcl-carousel]').forEach((root) => {
      if (root.__wxclCarousel) root.__wxclCarousel.destroy();
      root.__wxclCarousel = new WxclUgcCarousel(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initCarousels(document));
  document.addEventListener('shopify:section:load', (event) => initCarousels(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-wxcl-carousel]').forEach((root) => {
      root.__wxclCarousel?.destroy();
      delete root.__wxclCarousel;
    });
  });
})();
